var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.contextPassengers, function(item, index) {
        return _c(
          "fieldset",
          { staticClass: "custom-fieldset" },
          [
            _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  right: "0",
                  "margin-top": "-30px"
                }
              },
              [
                _c(
                  "v-btn",
                  {
                    staticStyle: { "background-color": "lightgrey" },
                    attrs: { icon: "" },
                    on: {
                      click: function($event) {
                        return _vm.removePerson(_vm.user)
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("close")])],
                  1
                )
              ],
              1
            ),
            _c("order-user-select", {
              attrs: {
                value: _vm.contextPassengers[index],
                "birth-date-required": _vm.birthDateRequired
              },
              on: {
                "update:value": function($event) {
                  return _vm.$set(_vm.contextPassengers, index, $event)
                }
              }
            })
          ],
          1
        )
      }),
      _c("v-btn", { staticClass: "primary", on: { click: _vm.addPeople } }, [
        _vm._v(_vm._s(_vm.$t("travelService.multipleUserSelect.addPerson")))
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }